module.exports = {
	"name": "scrollto-with-animation",
	"version": "4.5.2",
	"author": "David Sancho <dsnxmoreno@gmail.com> (https://github.com/davesnx)",
	"description": "Animated Scroll with requestAnimationFrame. For smooth animate scrollTo defining the easing, running at 60FPS and cross-browser",
	"license": "MIT",
	"main": "lib/index.js",
	"repository": {
		"type": "git",
		"url": "https://github.com/davesnx/scrollto-with-animation"
	},
	"files": [
		"src",
		"lib",
		"dist",
		"README.md"
	],
	"keywords": [
		"animation",
		"scrollTo",
		"60fps",
		"cross-browser",
		"requestAnimationFrame",
		"easeInQuad",
		"browserify"
	],
	"scripts": {
		"clean": "rm -rf dist/* && rm -rf lib/",
		"minify:dev": "NODE_ENV=dev webpack --watch",
		"minify:prod": "NODE_ENV=prod webpack -p",
		"compile:dev": "NODE_ENV=dev babel src --watch --out-dir lib",
		"compile:prod": "NODE_ENV=prod babel src --out-dir lib",
		"test:dev": "NODE_ENV=prod karma start test/karma.config.js --auto-watch",
		"test": "NODE_ENV=prod karma start test/karma.config.js --single-run",
		"build": "npm run clean && npm run compile:prod && npm run minify:prod",
		"prepublish": "npm run build"
	},
	"pre-commit": [
		"test"
	],
	"bugs": {
		"url": "https://github.com/davesnx/scrollto-with-animation/issues"
	},
	"dependencies": {
		"animation-frame": "^0.3.0"
	},
	"devDependencies": {
		"babel-cli": "^6.9.0",
		"babel-loader": "^6.2.2",
		"babel-preset-es2015": "^6.3.13",
		"babel-preset-stage-2": "^6.3.13",
		"jasmine-core": "^2.3.4",
		"json-loader": "^0.5.4",
		"karma": "^0.13.9",
		"karma-chrome-launcher": "^0.2.1",
		"karma-cli": "0.1.0",
		"karma-coverage": "^0.5.3",
		"karma-jasmine": "^0.3.6",
		"karma-phantomjs-launcher": "^0.2.1",
		"karma-sourcemap-loader": "^0.3.6",
		"karma-spec-reporter": "0.0.22",
		"karma-story-reporter": "^0.3.1",
		"karma-webpack": "^1.7.0",
		"phantomjs": "^1.9.18",
		"pre-push": "^0.1.1",
		"webpack": "^1.12.13"
	},
	"standard": {
		"parser": "babel-eslint",
		"global": [
			"jasmine",
			"it",
			"describe",
			"beforeEach",
			"afterEach",
			"expect",
			"spyOn"
		]
	}
};


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/scrollto-with-animation/package.json
// module id = av3W
// module chunks = 22 24